import PrimarySection from "../components/UI/PrimarySection";
import Heading from "../components/UI/Heading";
import galleryBackgroundImg from "../assets/images/gallery-bg.png";
import styles from "./GalleryPage.module.css";
import Address from "../components/Home/Address";
import Updates from "../components/Home/Updates";
import CtaLink from "../components/CtaLink/CtaLink";
import Cricket from "../components/Gallery/Cricket";
import Football from "../components/Gallery/Football";
import Badminton from "../components/Gallery/Badminton";
import MartialArts from "../components/Gallery/MartialArts";
import Yoga from "../components/Gallery/Yoga";

const GalleryPage = () => {
  return (
    <>
      <PrimarySection
        className={styles.section}
        backgroundImage={galleryBackgroundImg}
      >
        <Heading className={styles.heading} text1="Photo" text2="Gallery" />
      </PrimarySection>
      <CtaLink />
      <Cricket />
      <Football />
      <Badminton />
      <MartialArts />
      <Yoga />
      <Address />
      <Updates />
    </>
  );
};

export default GalleryPage;
